// Stub for Toasts
import React from 'react';

export const ToastContainer = ({ children }) => {
    return <div className="toast-container">{children}</div>;
};

// Export useToasts hook
export function useToasts() {
    const addToast = (config) => {
        console.log('Toast:', config);
    };

    return [
        { toasts: new Map() },
        { addToast }
    ];
}

export default ToastContainer;
